import BetasiNewsletter from "./BetasiNewsletter";

export default {
    "betasi-newsletter": BetasiNewsletter,
};
